import { type NoteEditorType } from '@/models/analytics/features/notes';
import { addDatadogRumAction } from '@/utils/tracing';
import { type ContentType } from '@heidi/schema/ml-scribe';

export const NOTE_SAVE_ATTEMPTED_ACTION = 'note_save_attempted';
export const NOTE_SAVE_SUCCEEDED_ACTION = 'note_save_succeeded';

/** Distinct from a real editor so a pre-settle save is never counted as `textarea`. */
export const UNRESOLVED_EDITOR_TYPE = 'unresolved';

export type NoteSaveEditorType = NoteEditorType | typeof UNRESOLVED_EDITOR_TYPE;

type NoteSaveActionProps = {
  session_id: string;
  editor_type: NoteSaveEditorType;
  content_type: ContentType;
  /** A length, never the content: the note is PHI. */
  content_length: number;
};

/**
 * RUM rather than Snowplow: save reliability is an operational signal, so it
 * wants the side that can alert and takes new dimensions without an Iglu
 * round-trip.
 */
export function emitNoteSaveAction(
  action: typeof NOTE_SAVE_ATTEMPTED_ACTION | typeof NOTE_SAVE_SUCCEEDED_ACTION,
  props: NoteSaveActionProps
): void {
  try {
    addDatadogRumAction(action, props);
  } catch {
    // A telemetry failure must never surface as a failed save.
  }
}
